import {
  Box,
  Button,
  Center,
  CircularProgress,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  HStack,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Spacer,
  Text,
} from "@chakra-ui/react";
import axios from "axios";
import Joi from "joi";
import { useState } from "react";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import OTPInput from "react-otp-input";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import validator from "validator";
import { SET_USER } from "../../store/auth/authActionType";
import styles from "./otppopup.module.scss";

const getValidationSchema = (role: any) => {
  return Joi.object({
    identifier: Joi.string().custom((v) => {
      if (validator.isEmail(v)) {
        return v;
      }
      const phoneRegex = /^\+([0-9]{1,3})\)?[\s]?[0-9]{6,14}$/;
      if (phoneRegex.test(v)) {
        return v;
      }
      throw new Error("Please Provide valid data");
    }),
    password: Joi.string().required(),
  });
};

function Login() {
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState<any>("");
  const [role, setRole] = useState<any>({ value: "ADMIN", label: "Admin" });
  const option = [
    { value: "ADMIN", label: "Admin" },
    { value: "SUB_ADMIN", label: "Sub Admin" },
  ];
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loginotp, setLogInOtp] = useState("");
  const [isOtpPopupOpen, setIsOtpPopupOpen] = useState(false);

  const login = () => {
    setErrorMsg("");

    const data = {
      identifier,
      password,
    };

    const loginSchema = getValidationSchema(role.value);

    const validationResult = loginSchema.validate(data);
    if (validationResult.error) {
      const error = validationResult.error;

      if (error.message.includes("identifier")) {
        setErrorMsg("Please enter valid Email / Phone");
      } else if (error.message.includes("password")) {
        setErrorMsg("Please enter Password");
      }

      setIsSubmitting(false);
      return;
    }

    const requestData: any = {
      password: password,
      role: role.value,
    };

    requestData.username = identifier;

    let url;
    if (role.value === "ADMIN") {
      url = `${process.env.REACT_APP_BASE_URL}/auth/admin`;
    } else {
      url = `${process.env.REACT_APP_BASE_URL}/auth/subadmin`;
    }

    axios({
      method: "post",
      url: url,
      data: requestData,
      withCredentials: true,
      headers: {
        "Access-Control-Allow-Credentials": "true",
      },
    })
      .then((res) => {
        setIsSubmitting(false);
        console.log("Response data:", res.data);

        if (role.value === "ADMIN") {
          localStorage.setItem("otpDataResponse", res.data.data.id);
          setIsOtpPopupOpen(true);
        } else {
          handleSuccessfulLogin(res);
        }
      })
      .catch((error) => {
        setIsSubmitting(false);
        if (error === "Error: Network Error") {
          setErrorMsg(
            "Something went wrong, please try again after some time or Refresh the Page."
          );
        } else if (error.response?.status === 401) {
          setErrorMsg(error.response.data.message);
        } else if (error.response?.status === 500) {
          setErrorMsg("Something happened wrong try again after sometime.");
        } else if (error.response?.status === 422) {
          setErrorMsg(error.response.data.message);
        } else if (error.response?.status === 415) {
          setErrorMsg(error.response.data.message);
        }
      });
  };

  const handleSuccessfulLogin = (res: any) => {
    localStorage.setItem(
      "token",
      res.headers["X-Auth-Token"] || res.headers["x-auth-token"]
    );
    dispatch({ type: SET_USER, payload: res.data.data });
    navigate("../");
    localStorage.removeItem("otpDataResponse");
  };

  const handleOtpSubmit = async () => {
    let otpData = localStorage.getItem("otpDataResponse");
    let tkn = localStorage.getItem("token");
    if (loginotp.length === 4) {
      try {
        setIsSubmitting(true);

        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/auth/admin/verify-otp`,
          {
            otp: loginotp,
            id: otpData,
          },
          {
            headers: {
              Authorization: `${tkn}`,
            },
          }
        );

        if (response.status === 200) {
          setIsOtpPopupOpen(false);
          handleSuccessfulLogin(response);
        }
      } catch (error: any) {
        console.error("Error verifying OTP:", error);
        setErrorMsg(error.response?.data?.message || "Failed to verify OTP");
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const onClose = () => {
    setIsOtpPopupOpen(false);
    setLogInOtp("");
  };

  const handleResendOtp = async () => {
    let otpData = localStorage.getItem("otpDataResponse");
    let tkn = localStorage.getItem("token");
    if (otpData) {
      try {
        await axios.get(
          `${process.env.REACT_APP_BASE_URL}/auth/admin/resend-otp`,
          {
            headers: {
              Authorization: `${tkn}`,
            },
          }
        );
      } catch (error) {
        console.error("Error resending OTP:", error);
      }
    }
  };

  return (
    <>
      <Flex
        minHeight="100vh"
        width="full"
        align="center"
        justifyContent="center"
        gap={10}
        background="#F9F9F9"
        padding={"50px"}
      >
        <div
          style={{
            width: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            borderWidth={1}
            px={4}
            width="full"
            maxWidth="400px"
            borderRadius={"10px"}
            textAlign="center"
            border={"none"}
            background={"white"}
          >
            <Box p={4}>
              <Box>
                <Image
                  src="/logo.png"
                  alt="AI"
                  margin={"10px auto"}
                  align="center"
                />
                <Text>
                  <br></br>
                </Text>
                <Heading textAlign={"left"} mb={5} fontSize="27px">
                  Sign In
                </Heading>
                <Text textAlign={"left"} color="red">
                  {errorMsg}
                </Text>
              </Box>
              <Box mb={8} mt={2} textAlign="left">
                <FormControl isRequired>
                  <FormLabel>Email address</FormLabel>
                  <Input
                    type="email"
                    placeholder="Enter your Email"
                    onChange={(e) => setIdentifier(e.target.value)}
                  />
                </FormControl>

                <FormControl mt={4} isRequired>
                  <FormLabel>Password</FormLabel>
                  <InputGroup size="md">
                    <Input
                      type={show ? "text" : "password"}
                      placeholder="Enter your password"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          setIsSubmitting(true);
                          login();
                        }
                      }}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <InputRightElement width="4.5rem">
                      <Box cursor={"pointer"} onClick={handleClick}>
                        {show ? <IoEyeOffOutline /> : <IoEyeOutline />}
                      </Box>
                    </InputRightElement>
                  </InputGroup>
                </FormControl>

                <FormControl mt={4} isRequired>
                  <Flex width="100%">
                    <HStack>
                      <FormLabel>Login as a </FormLabel>
                      <Spacer></Spacer>
                    </HStack>
                  </Flex>
                  <Select
                    value={role}
                    name="category"
                    onChange={(event) => {
                      setRole(event);
                      setErrorMsg("");
                    }}
                    options={option}
                    placeholder="Select admin"
                  />
                </FormControl>
                {role.value === "ADMIN" && (
                  <Text
                    textAlign={"right"}
                    color="red"
                    fontSize={"12px"}
                    mt={2}
                    cursor={"pointer"}
                  >
                    <a
                      href={`${process.env.REACT_APP_BASE_URL}/auth/admin/forgot-password`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Forgot password?
                    </a>
                  </Text>
                )}

                {isSubmitting ? (
                  <Flex
                    bg="white.500"
                    color="gery.500"
                    width="full"
                    justifyContent="center"
                    mt={4}
                  >
                    <Center>
                      <CircularProgress
                        size={7}
                        isIndeterminate
                        color="green.500"
                        m={1}
                      />
                    </Center>
                  </Flex>
                ) : (
                  <Button
                    bg="#E24441"
                    color="white"
                    width="full"
                    mt={5}
                    onClick={() => {
                      setIsSubmitting(true);
                      login();
                    }}
                  >
                    Sign In
                  </Button>
                )}
              </Box>
            </Box>
          </Box>
        </div>
        <Box width="50%">
          <Image
            src="/loginbg.png"
            alt="AI"
            objectFit="cover"
            maxWidth="100%"
            align="center"
            maxHeight="80vh"
          />
        </Box>
      </Flex>
      {isOtpPopupOpen && (
        <>
          <div className={styles.verificationPopupOverlay}>
            <div className={styles.otpOverlay}>
              <div className={styles.otpContainer}>
                <h2>Verify Admin Login</h2>
                <p className={styles.otpSubtext}>
                  Your code was sent to you via registered email
                </p>

                <div className={styles.otpDiv}>
                  <div className={styles.otpInputs}>
                    <OTPInput
                      value={loginotp}
                      onChange={setLogInOtp}
                      numInputs={4}
                      shouldAutoFocus={true}
                      inputType="number"
                      renderInput={(props) => (
                        <input {...props} className={styles.otpInput} />
                      )}
                    />
                  </div>
                </div>
                <div className={styles.otpBtn}>
                  <button className={styles.otpCancelButton} onClick={onClose}>
                    Cancel
                  </button>
                  <button
                    className={styles.otpSubmitButton}
                    onClick={handleOtpSubmit}
                    disabled={loginotp.length !== 4 || isSubmitting}
                  >
                    {isSubmitting ? "Verifying..." : "Submit"}
                  </button>
                </div>
                <div className={styles.resend}>
                  <span>Didn&apos;t receive the code? </span>{" "}
                  <a href="#" onClick={handleResendOtp}>
                    {" "}
                    Resend
                  </a>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Login;
